export default __webpack_public_path__ + "static/media/SD-rudra-homam-img.ef34e748.png";